import { getUserName } from '../helpers';


export const getSkillDataAPI = async (skill, callback)=> {
  try {
    //const tenantToUse = new URLSearchParams(window.location.search).get('platform')
    const queryParam = new URLSearchParams({
      content: 'skills',
      skill_id:skill,
      return_items:"True",
      //tenant:tenantToUse ?? getTenant()
    });
    const url = `${process.env.REACT_APP_IBL_DM_URL}/api/search/catalog/?${queryParam}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + localStorage.getItem('dm_token'),
      },
    })
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to fetch skill');
    }
    const data = await response.json();
    if(!(Array.isArray(data?.results) && data.results.length > 0)){
      throw new Error('Failed to fetch skill');
    }
    callback(data?.results[0] ?? {})
  } catch (error) {
    callback({})
  }
}